<template>
  <div>
    <trips-history-table
      @showDownloadModal="showDownloadModal"
      :loadBookingsCallBackFn="loadData"
    ></trips-history-table>

    <dialog-wrapper ref="downloadModal" :width="600">
      <template v-slot:dialogContent>
        <trip-download-form
          @closeDialog="closeDialog"
        />
      </template>
    </dialog-wrapper>
  </div>

</template>

<script>
import { getRoles } from '@/mixins/authentication.mixins';
import { entityLoader } from '@/mixins/entityLoader.mixins';
import TripsHistoryTable from '@/components/tripsHistory/TripsHistoryTable.vue';
import DialogWrapper from '@/components/elements/DialogWrapper.vue';
import TripDownloadForm from '@/components/tripsHistory/TripDownloadForm.vue';
import { CHANNEL_ADMIN } from '@/helpers/userRoles';
import {mapGetters} from "vuex";

export default {
  name: 'trips-view',
  mixins: [entityLoader, getRoles],
  components: {
    TripsHistoryTable, DialogWrapper, TripDownloadForm,
  },
  data() {
    return {
      CHANNEL_ADMIN,
    };
  },
  computed: {
    ...mapGetters('accountsApiStore', ['accountSelected'])
  },
  methods: {
    hasAccess(role) {
      return this.userRoles ? this.userRoles.filter((userRole) => userRole.name === role).length > 0 : false;
    },
    async loadData(options) {
      if(this.hasAccess(CHANNEL_ADMIN)) {
        return this.loadBookingsForChannelAdmin(options);
      } else {
        return this.loadBookingsForCorporationAdmin(options);
      }
    },
    async loadBookingsForChannelAdmin(options){
      // Get data from store and return them
      const result = await this.$store.dispatch('tripsHistory/getFleetHistory', options);
      return result;
    },
    async loadBookingsForCorporationAdmin(options) {
      const result = await this.$store.dispatch('tripsHistory/getCorporationsHistory', options);
      return result;

    },
    showDownloadModal() {
      this.$refs.downloadModal.openDialog();
    },
    closeDialog() {
      this.$refs.downloadModal.close();
    },
  },
};
</script>
